<template>
  <v-container v-if="song" class="elevation-11 pa-3">
      <v-layout row wrap>
        <v-flex xs12>
        <h2 class="mb-4">Edit Song</h2>
        <v-form>
          <v-text-field
            v-model.trim="song.title"
            label="Song title"
            id="title"
            required
          ></v-text-field>
          <v-text-field
            v-model.trim="song.artist"
            label="Artist"
            id="artist"
            required
          ></v-text-field>
          <v-textarea
            box
            name="notes"
            label="Notes"
            id="notes"
            v-model.trim="song.notes"
            required
          ></v-textarea>
          <v-btn small color="secondary" class="mt-3 ml-0" @click="saveEdits">Save edits</v-btn>
          <!-- <v-btn small color="secondary" class="mt-3 ml-0" @click="deleteSong">Delete</v-btn> -->
          <v-btn small class="mt-3 ml-0" @click="cancelEdit">Cancel</v-btn>
        </v-form>
        </v-flex>
      </v-layout>
  </v-container>
</template>

<script>
import { copyObject } from '../../mixins/utilities.js'
export default {
  props: ["song"],
  data() {
    return {
      // songOrig: copyObject(this.song)
    }
  },
  methods: {
    saveEdits() {
      const objSong = {
        title: document.getElementById('title').value,
        artist: document.getElementById('artist').value,
        notes: document.getElementById('notes').value,
        songId: this.song.songId,
        docId: this.$store.state.loadedSonglist.docId
      }
      this.$store.commit('editSong', objSong)
      this.saveSonglist()
    },
    saveSonglist() {
      this.$store.dispatch('editSonglist')
    },
    cancelEdit() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.container {
  padding: 0px;
}

.v-textarea {
  font-size: .9rem;
}
</style>